import { Box, IconButton, styled, Typography } from '@mui/material'
import { ArrowUpIcon } from '$common/icons/arrow-up'
import { ArrowDropDownIcon } from '$common/icons'
import { toLocale } from '$func/text'
import { SEND_FIELD_DEFAULT_HEIGHT } from '$comp/_app/components/chat/components/conf'
import { t } from '$i18n'

const Root = styled(Box)`
  height: ${SEND_FIELD_DEFAULT_HEIGHT}px;
  padding: 0 12px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background-color: white;
  z-index: 1;
`
const StyledIconButton = styled(IconButton)`
  width: 30px;
  height: 30px;
  /* @noflip */
  margin-left: 15px;
  &.Mui-disabled {
    opacity: 0.5;
  }
`

export function SearchResultNavigator({
  currentIndex,
  resultLength,
  loading,
  onUp,
  onDown,
}: {
  currentIndex: number
  resultLength: number
  loading: boolean
  onUp: () => void
  onDown: () => void
}) {
  return (
    <Root dir="rtl">
      <Box>
        <StyledIconButton
          disabled={loading || currentIndex + 1 >= resultLength}
          onClick={onUp}
        >
          <ArrowUpIcon />
        </StyledIconButton>
        <StyledIconButton
          disabled={loading || currentIndex === 0}
          onClick={onDown}
        >
          <ArrowDropDownIcon sx={{ color: 'secondary.main' }} />
        </StyledIconButton>
      </Box>
      {!loading ? (
        <Typography variant="subtitle3" color="primary">
          {resultLength
            ? `${toLocale(currentIndex + 1)} ${t('common.from')} ${toLocale(
                resultLength,
              )}`
            : t('emptyState.noResultFound')}
        </Typography>
      ) : null}
    </Root>
  )
}
